import { Button, Modal, Select, TextInput } from 'flowbite-react';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  formatNumbers,
  formatNumbersDisplayOnly,
  onlyNumberInput,
} from '../../../Utils';
import Loader from '../../Common/Loader';
import { DeliveryItem } from '../../../Models/DeliveryItem';
import DeliveryApi from '../../../Api/DeliveryApi';
import CommonApi from '../../../Api/CommonApi';
import { QbreferenceItem } from '../../../Models/QbreferenceItem';

export default function DeliveryItemNonInventoryModal({
  show,
  setShow,
  deliveryId,
  getDeliveryItems,
  getSchedulerData = undefined,
  selectedDeliveryItem,
  setSelectedDeliveryItem,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  deliveryId: number;
  getDeliveryItems: () => Promise<void> | undefined;
  getSchedulerData?: () => void;
  selectedDeliveryItem: DeliveryItem | null;
  setSelectedDeliveryItem: React.Dispatch<
    React.SetStateAction<DeliveryItem | null>
  >;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [noninventoryListData, setnoninventoryListData] = useState<
    QbreferenceItem[]
  >([]);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [formData, setFormData] = useState<DeliveryItem>({
    id: 0,
    deliveryId: deliveryId,
    dateOrdered: null,
    quantity: null,
    price: null,
    clientLocationAssetId: null,
    defService: null,
    defQuantity: null,
    qbitemId: null,
    description: null,
    defPrice: null,
    inventoryTypeId: null,

    clientLocationAsset: null,
    inventoryType: null,
    qbitem: null,
  });

  const getInventory = useCallback(() => {
    try {
      setIsLoading(true);
      return CommonApi.getQbreferenceItems()
        .then((res) => {
          setnoninventoryListData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          toast.error('Error');
          setIsLoading(false);
        });
    } catch (error) {
      console.error(error);
      toast.error('Error');
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getInventory();
  }, [getInventory]);

  const handleSetInitialValues = () => {
    const values = selectedDeliveryItem
      ? {
          ...selectedDeliveryItem,
        }
      : {
          id: 0,
          deliveryId: deliveryId,
          dateOrdered: null,
          quantity: null,
          price: null,
          clientLocationAssetId: null,
          defService: null,
          defQuantity: null,
          qbitemId: null,
          description: null,
          defPrice: null,
          inventoryTypeId: null,

          clientLocationAsset: null,
          inventoryType: null,
          qbitem: null,
        };
    setFormData(values as DeliveryItem);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [selectedDeliveryItem]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      deliveryId: deliveryId,
      dateOrdered: null,
      quantity: null,
      price: null,
      clientLocationAssetId: null,
      defService: null,
      defQuantity: null,
      qbitemId: null,
      description: null,
      defPrice: null,
      inventoryTypeId: null,

      clientLocationAsset: null,
      inventoryType: null,
      qbitem: null,
    };
    setFormData(values as DeliveryItem);
    setButtonDisabled(false);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeCurrencyInput = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    const formattedValue = formatNumbers(value);
    setFormData((prevData) => ({ ...prevData, [name]: formattedValue }));
  };

  function cleanMoneyValues(formData: DeliveryItem) {
    formData.price = Number((formData.price ?? 0).toString().replace(',', ''));
  }
  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    cleanMoneyValues(formData);
    return await DeliveryApi.addUpdateDeliveryItem(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success('Save Success');
          setIsLoading(false);
          setButtonDisabled(false);
          handleResetFormValues();
          getDeliveryItems();
          if (getSchedulerData) {
            getSchedulerData();
          }
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  function onCloseModal() {
    handleResetFormValues();
    setSelectedDeliveryItem(null);
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='2xl' onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <div className='w-full'>
                <div className='mx-1 flex items-end justify-center'>
                  <div className='flex flex-1 justify-center'>
                    <h1 className='text-gray-900 font-bold text-4xl'>
                      {selectedDeliveryItem ? 'Edit' : 'Add'} Non Inventory Item
                    </h1>
                  </div>
                </div>
              </div>
              <div>
                <div className='container mx-auto p-2'>
                  <div className='md:flex no-wrap md:-mx-2 '>
                    <div className='w-full'>
                      <div className='bg-white'>
                        <hr className='bg-gray-300 h-[5px]'></hr>
                        <form
                          id='DeliveryItemNonInventoryForm'
                          onSubmit={onSubmit}
                        >
                          <div className='text-gray-500'>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Item:
                                </div>
                              </div>
                              <div className='w-full'>
                                <Select
                                  id='qbitemId'
                                  name='qbitemId'
                                  onChange={handleChangeSelect}
                                  value={formData.qbitemId ?? ''}
                                  sizing='md'
                                  required
                                >
                                  <option value={''}>(Select)</option>
                                  {noninventoryListData
                                    .sort((a, b) =>
                                      (a.qbitemName ?? '').localeCompare(
                                        b.qbitemName ?? ''
                                      )
                                    )
                                    .map((inv) => (
                                      <option key={inv.id} value={inv.id}>
                                        {inv.qbitemName}
                                      </option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                            <hr className='bg-gray-300 h-[2px]'></hr>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Description:
                                </div>
                              </div>
                              <div className='w-full'>
                                <TextInput
                                  id='description'
                                  name='description'
                                  type='text'
                                  onChange={handleChangeInput}
                                  value={formData.description ?? ''}
                                  sizing='md'
                                />
                              </div>
                            </div>
                            <hr className='bg-gray-300 h-[2px]'></hr>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Quantity:
                                </div>
                              </div>
                              <div className='w-full'>
                                <TextInput
                                  id='quantity'
                                  name='quantity'
                                  type='text'
                                  onChange={handleChangeInput}
                                  value={formData.quantity ?? ''}
                                  sizing='md'
                                />
                              </div>
                            </div>
                            <hr className='bg-gray-300 h-[2px]'></hr>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Price:
                                </div>
                              </div>
                              <div className='w-full'>
                                <TextInput
                                  id='price'
                                  name='price'
                                  type='text'
                                  placeholder='0.00'
                                  onChange={handleChangeCurrencyInput}
                                  onKeyDown={(event) => {
                                    if (onlyNumberInput(event)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  value={formData.price ?? ''}
                                  sizing='md'
                                  addon='$'
                                />
                              </div>
                            </div>
                            <hr className='bg-gray-300 h-[2px]'></hr>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Total:
                                </div>
                              </div>
                              <div className='w-full'>
                                $
                                {formatNumbersDisplayOnly(
                                  (formData.quantity ?? 0) *
                                    (formData.price ?? 0)
                                )}
                              </div>
                            </div>
                          </div>
                          <div className='flex justify-end pt-2'>
                            <Button
                              disabled={buttonDisabled}
                              type='submit'
                              className='buttonMain'
                              form='DeliveryItemNonInventoryForm'
                            >
                              Save
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
